import React, { useCallback, useMemo } from 'react';

import { Text } from '@sravni/react-design-system/lib/Typography';
import { UserManager } from '@sravni/utils/lib/auth';

import { sendReviewEvent } from '../../../../../helpers/analyticsEvents';
import { AuthInlineForm } from '../../../../UI/AuthInlineForm';
import { EVENT_ACTIONS } from '../../../helpers/analytics';

import { TDefaultValuesForAuthorization } from './interfaces';

type TAuthorizationStepProps = {
  onChangeAgreement: (value: boolean) => void;
  onClickSubmitAuthButton: () => void;
  defaultValues: TDefaultValuesForAuthorization;
  eventLabel: string[];
  onSuccessAuth?: () => void;
};

const userManager = new UserManager();

export const AuthorizationStep: React.FC<TAuthorizationStepProps> = (props) => {
  const { defaultValues, onChangeAgreement, onClickSubmitAuthButton, eventLabel, onSuccessAuth } = props;

  const isDataFromExtraInfo = useMemo(() => Object.entries(defaultValues).filter(Boolean).length > 0, [defaultValues]);

  const onSubmit = useCallback(() => {
    onClickSubmitAuthButton();
  }, [onClickSubmitAuthButton]);

  const onLogin = useCallback(() => {
    onSuccessAuth?.();
  }, [onSuccessAuth]);

  const onGetOTPButtonClick = useCallback(() => {
    sendReviewEvent({ label: eventLabel, action: EVENT_ACTIONS.GET_CODE });
  }, [eventLabel]);

  const onChangeAgreementValue = useCallback(
    (event) => {
      onChangeAgreement?.(event.target.checked);
    },
    [onChangeAgreement],
  );

  return (
    <div>
      <Text size={16} strong className={'h-mb-8'}>
        Войдите на Сравни, чтобы опубликовать отзыв
      </Text>
      {isDataFromExtraInfo && (
        <Text size={14} className={'h-mb-8'}>
          Мы подставили ваши данные, но вы можете указать их заново
        </Text>
      )}

      <AuthInlineForm
        userManager={userManager}
        metaInfo={{
          source: 'Форма создания отзыва',
        }}
        onLogin={onLogin}
        onSubmit={onSubmit}
        onGetOTPButtonClick={onGetOTPButtonClick}
        onChangeAgreementValue={onChangeAgreementValue}
        defaultValues={defaultValues}
        enableAutoSubmit={true}
      />
    </div>
  );
};
